var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAwesomeUserTie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-user-tie",
    "data-name": "Icon awesome-user-tie",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-tie-2",
    "data-name": "Icon awesome-user-tie",
    d: "M35,40A20,20,0,1,0,15,20,20,20,0,0,0,35,40Zm14.969,5.094L42.5,75l-5-21.25,5-8.75h-15l5,8.75L27.5,75,20.031,45.094A20.963,20.963,0,0,0,0,66v6.5A7.5,7.5,0,0,0,7.5,80h55A7.5,7.5,0,0,0,70,72.5V66A20.963,20.963,0,0,0,49.969,45.094Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeUserTie);
export default __webpack_public_path__ + "static/media/Icon_awesome-user-tie.d7e4055ecd5140bbdf52804ffa90cfb1.svg";
export { ForwardRef as ReactComponent };